import axios from '../../../commons/gdprcontrol-axios'

const partnerSkeleton = {
  id: null,
  name: null,
  organization: {id: null, name: ''},
  tax_id: '',
  registration_number: '',
  address: '',
  contact_name: '',
  contact_phone: '',
  contact_email: ''
}

const state = {
  partner: Object.assign({}, partnerSkeleton)
}

const getters = {
  getPartner: state => state.partner
}

const actions = {
  fetchPartner: async ({ commit }, partnerId) => {
    return axios.get(`/api/partner/${partnerId}/`)
      .then(response => {
        commit('setPartner', response.data)
      })
      .catch(error => {
        alert('Hiba a partner letöltése közben')
        throw error
      })
  },

  saveNewPartner: async ({ commit, state }) => {
    return axios.post('/api/partner/', state.partner)
      .then(response => {
        commit('setPartner', response.data)
      })
      .catch(error => {
        alert('Hiba a partner mentése közben')
        throw error
      })
  }
}

const mutations = {
  setPartner (state, partner) {
    state.partner = partner
  },

  setAttribute (state, { name, value }) {
    state.partner[name] = value
  },

  resetPartner (state) {
    state.partner.organization = {id: null, name: ''}
    state.partner = Object.assign({}, partnerSkeleton)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/partners/details.js